<div *ngIf="iconFile | async as i; else loadingIcon" [class.features-icon]="!dashboard"
  [class.dashboard-icon]="dashboard" [attr.singlecolor]="i?.singleColor">
  <ng-container *ngIf="i.svgCode !== undefined; else imgIcon">
    <div class="svg-icon" [innerHTML]="i.svgCode | safe : 'html'" [class.disabled]="disabled"></div>
  </ng-container>
</div>
<div *ngIf="isTeaser" class="learn-more">
  <button class="btn btn-learn-more" *ngIf="!canCreateTeaser">MEHR ERFAHREN</button>
  <button class="btn btn-learn-more" *ngIf="canCreateTeaser">TEASER ERSTELLEN</button>
</div>

<ng-template #imgIcon>
  <a class="hover-image" href="#">
    <img class="externe-img-icon" [src]="iconFile | async" [class.disabled]="disabled" alt="?" draggable="false" />
    <img *ngIf="hoverIconFile | async" class="externe-img-icon hide" [src]="hoverIconFile | async" alt=""
      draggable="false" />
  </a>
</ng-template>

<ng-template #loadingIcon>
  <div [class.features-icon]="!dashboard" [class.dashboard-icon]="dashboard"></div>
</ng-template>